import React from "react";
import { Link } from "react-router-dom";

function AaerIntroSection() {
  return (
    <section className="aaer-intro-section" aria-labelledby="aaer-intro-title">
      <div className="container">
        <div className="aaer-intro-card">
          <div className="row align-items-center g-5">
            <div className="col-12 col-lg-7">
              <div className="aaer-kicker">Legal technology spotlight</div>
              <h2 id="aaer-intro-title">
                Meet AAER, an all-in-one legal companion for modern practice.
              </h2>
              <p>
                All Appeal Electronic Reports brings legal research, reported
                judgments, current laws, contract tools, precedents, and
                continuing legal education into one connected platform.
              </p>
              <div className="aaer-intro-actions">
                <Link className="btn btn-primary" to="/aaer-legal-technology">
                  <span>
                    Discover AAER <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Discover AAER <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
                <span className="aaer-intro-note">
                  Research smarter. Work with greater clarity.
                </span>
              </div>
            </div>

            <div className="col-12 col-lg-5">
              <div className="aaer-product-mark" aria-label="AAER">
                <div className="aaer-product-mark-topline">
                  All Appeal Electronic Reports
                </div>
                <div className="aaer-product-mark-word">AAER</div>
                <div className="aaer-product-mark-grid">
                  <span>Research</span>
                  <span>Judgments</span>
                  <span>Contracts</span>
                  <span>Learning</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AaerIntroSection;
